import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useReturnOrderPendingList = ({
  branchFilter,
  myBranchesFilter,
  search,
  page,
  pageSize,
}) => {
  const filter = {
    filter: { noFilter: null, branchFilter: null, searchTerm: search },
    paging: { pageIndex: page },
  };

  if (branchFilter === "Mine") {
    filter.filter.branchFilter = "Mine";
  } else if (branchFilter === "All" && myBranchesFilter === "All") {
    filter.filter.branchFilter = "All";
  } else {
    filter.filter.branchFilter = myBranchesFilter;
  }

  return useQuery({
    queryKey: ["receivedreturnorderlist", filter],
    queryFn: async () =>
      callApi({
        path: "receivedreturnorderlist",
        command: "",
        data: JSON.stringify({ list: filter }),
      }),
    placeholderData: keepPreviousData,
    staleTime: 5000,
  });
};
